<template>
  <div>
    <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
      <v-card v-if="campaign">
        <v-card-title class="title">Change Campaign Status</v-card-title>
        <v-card-text class="body-2">
          <v-row>
            <v-col xs="6">
              <v-text-field
                label="Current Status"
                filled disabled
                :value="displayStatus(campaign.status)"
              ></v-text-field>
            </v-col>
            <v-icon>mdi-arrow-right-thick</v-icon>
            <v-col xs="6">
              <v-select
                v-model="selectedStatus"
                :items="status_options"
                item-text="display"
                item-value="status"
                :menu-props="{ maxHeight: '400' }"
                label="New Status"
                filled
                hint="Select new Campaign Status"
                persistent-hint
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" id="close" text @click.native="$emit('input')">Close</v-btn>
          <v-btn color="green" text @click="changeStatus()" :disabled="selectedStatus === campaign.status">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Update Creator Email Modal -->
    <update-campaign-quarter-modal
    v-model="campaignQuarterDialog"
    :value="campaignQuarterDialog"
    :campaignID="viewCampaignId"
    :multipleCampaignIds="multipleCampaignIds"
    @updated="closeModal" />
  </div>
</template>

<script>
import campaignAPIs from './campaignAPIs';
import config from '@/config';
import UpdateCampaignQuarterModal from './UpdateCampaignQuarterModal'
export default {
  props: {
    value: Boolean,
    campaign: Object,
    campaignIds: Array
  },
  components: {
    UpdateCampaignQuarterModal
  },
  data() {
    return {
      campaignStatusDisplay: config.campaignStatusDisplay,
      campaignStatuses: config.campaignStatus,
      campaignData: null,
      options: [0, 1, 2, 3, 4, 5],
      selectedStatus: null,
      campaignQuarterDialog: false,
      viewCampaignId: null,
      multipleCampaignIds: []
    };
  },
  methods: {
    changeStatus() {
      if (this.selectedStatus === null) {
        this.$swal({
          title: 'Error',
          type: 'error',
          text: 'Empty Status'
        })
      } else {
        if (this.selectedStatus === config.campaignStatus.REVIEW) {
          this.openUpdateCampaignQuarterModal()
          return
        }
        if (this.campaignIds && this.campaignIds.length > 0) {
          // if bulk change
          this.changeBulkCampaignStatus()
          return;
        }
        campaignAPIs
          .changeStatus(this.campaignData.id, this.selectedStatus)
          .then(response => {
            if (response.success) {
              this.$emit('updated', true)
              this.$emit('input')
              this.$swal({
                title: 'Success',
                text: 'Campaign Status Changed. Do you want to go to updated stage?',
                type: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No, Stay here'
              }).then((result) => {
                if (result.value) {
                  this.$router.push({ name: this.displayStatus(this.selectedStatus) }) // because router name is same with campaign display name
                } else {
                  this.closeModal()
                }
              })
            } else {
              this.$swal('Campaign Status Changed Failed')
            }
          })
          .catch(err => console.error(err));
      }
    },
    changeBulkCampaignStatus() {
      campaignAPIs
        .changeBulkStatus(this.campaignIds, this.selectedStatus)
        .then(response => {
          if (response.success) {
            this.$emit('updated', true);
            this.$emit('input');
            this.$swal({
              title: 'Success',
              text: 'Campaign Status Changed. Do you want to go to updated stage?',
              type: 'success',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No, Stay here'
            }).then(result => {
              if (result.value) {
                this.$router.push({ name: this.displayStatus(this.selectedStatus) }); // because router name is same with campaign display name
              } else {
                this.closeModal()
              }
            });
          } else {
            this.$swal('Campaign Status Changed Failed');
          }
        })
        .catch(err => console.error(err));
    },
    openUpdateCampaignQuarterModal() {
      this.$swal({
        title: 'Push to Review',
        html: 'Are you sure you want to push to review stage',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          if (this.campaignIds && this.campaignIds.length > 0) {
            this.multipleCampaignIds = this.campaignIds
          } else {
            this.viewCampaignId = this.campaignData.id
          }
          this.campaignQuarterDialog = true
        }
      })
    },
    displayStatus(status) {
      return config.campaignStatusDisplay[status]['display'] + ' campaigns'
    },
    closeModal() {
      this.$emit('updated', true)
      this.$emit('input')
    }
  },
  computed: {
    status_options: function() {
      let data = []
      Object.entries(this.campaignStatuses).forEach(item => {
        // Rate_Card and Pairing_Brief Status are disabled for now
        if (item[1] !== this.campaignStatuses.RATE_CARD && item[1] !== this.campaignStatuses.PAIRING_BRIEF) {
          data.push({
            status: item[1],
            display: this.campaignStatusDisplay[item[1]]['display'] + ' campaigns'
          })
        }
      })
      return data;
    }
  },
  watch: {
    campaign(newCampaign) {
      if (newCampaign !== null) {
        this.campaignData = newCampaign;
        this.selectedStatus = newCampaign.status
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// ChangeCampaignStatusModal.vue?655a6f1d